import { InputCpfCnpj } from "app/components/inputs/InputCpfCnpj";
import { InputNumerico } from "app/components/inputs/InputNumerico";
import { SelecaoComFiltro } from "app/components/selecao-com-filtro/SelecaoComFiltro";
import { Classificacao, Profissao } from "app/types/comissoes/DadosBasicosIndicadores";
import clsx from "clsx";
import { FormikErrors, useFormik } from "formik";
import globalMU from "globalMU";
import * as R from "ramda";
import React, { useEffect, useState } from "react";
import { IIndicador } from "../../../types/IIndicador";
import { Vendedor } from "../../../types/Vendedor";
import { InputMascara } from "../../inputs/InputMascara";
import { InputMascaraDinamica } from "../../inputs/InputMascaraDinamica";
import { InputData } from "app/components/inputs/InputData";

const estilosInput = require("../../../estilos/inputs.module.scss").default;
const estilosDadosBasicos = require("./tela-dados-basicos.module.scss").default;

export type TelaDadosBasicosProps = {
  dadosIndicador: IIndicador;
  classificacoes: Classificacao[];
  profissoes: Profissao[];
  vendedores: Vendedor[];
  formularioValidado: boolean;
  cpfCnpjEValido: number;
  podeSalvar: boolean;
  onVendedorModificado: (pesquisa: string) => void;
  onValidarFormulario: (valor: boolean) => void;
  onValidarCpfCnpj: (cpfCnpj: string) => void;
  manterDadosTemporarios: (indicador: IIndicador) => void;
  onErrorValidacao: (erros: FormikErrors<IIndicador>) => void;
};

export const TelaDadosBasicos = (props: TelaDadosBasicosProps) => {
  const formik = useFormik({
    initialValues: { ...props.dadosIndicador, CpfCnpj: props.dadosIndicador?.CpfCnpj?.replace(/\D/g, "") },
    onSubmit: (values, { }) => { },
    enableReinitialize: true,
    validate: (values) => {
      const mensagemObrigatorio = (campo) => `O campo "${campo}" é obrigatório.`;
      return R.pickBy((val) => globalMU.isNotNullOrEmpty(val), {
        Nome: !values.Nome ? mensagemObrigatorio("Nome") : undefined,
        Email: !values.Email ? mensagemObrigatorio("Email") : undefined,
        Telefone: !values.Telefone ? mensagemObrigatorio("Telefone") : undefined,
        CodigoClassificacao: !values.CodigoClassificacao ? mensagemObrigatorio("Classificacao") : undefined,
      } as FormikErrors<IIndicador>);
    }
  });

  const [carregandoVendedor, setCarregadoVendedor] = useState(false)


  const onValidacaoFormularioVerdadeiro = async () => {
    props.onValidarFormulario(true);
    props.onErrorValidacao(null);
  };

  const onValidacaoFormaularioFalso = async (erros: FormikErrors<IIndicador>) => {
    props.onValidarFormulario(false);
    props.onErrorValidacao(erros);
  };

  const onValidarDadosFormulario = async () => {
    const erros = await formik.validateForm(formik.values)
    Object.keys(erros).length == 0 ? onValidacaoFormularioVerdadeiro() : onValidacaoFormaularioFalso(erros);
  }

  useEffect(() => {
    props.manterDadosTemporarios(formik.values);
    onValidarDadosFormulario()
  }, [formik.values]);

  useEffect(() => {
    setCarregadoVendedor(false)
  }, [props.vendedores])


  const cpfCnpj = <div className="_mb-[4px]">
    <label className="_py-1 _pr-3">CPF / CNPJ</label>
    <InputCpfCnpj
      className={clsx("input-menor", estilosDadosBasicos.inputTam3, props.cpfCnpjEValido == 0 ? estilosDadosBasicos.validador : null)}
      name="CpfCnpj"
      id="TelaDadosBasicos_CpfCnpj"
      autoFocus
      disabled={!props.podeSalvar}
      cpfCnpj={formik.values.CpfCnpj}
      onCpfCnpjModificado={(cpfCnpj) => {
        formik.setFieldValue("CpfCnpj", cpfCnpj)
        cpfCnpj == null ?
          props.onValidarCpfCnpj("___.___.___-__") :
          props.onValidarCpfCnpj(cpfCnpj)
      }}
    />
  </div>

  const nome = <div className="_mb-[4px]">
    <label className={clsx(`_py-1 _pr-3 ${estilosInput.labelObrigatorio}`)} >
      Nome
    </label>
    <input
      disabled={!props.podeSalvar}
      value={formik.values.Nome ?? ''}
      onChange={formik.handleChange("Nome")}
      className={clsx(estilosInput.inputPadrao, estilosDadosBasicos.inputTam5,
        formik.errors.Nome != undefined && props.formularioValidado && estilosDadosBasicos.validador
      )}
    />
  </div>

  const razaoSocial = <div className="_mb-[4px]">
    <label className="_py-1 _pr-3">Razão Social</label>
    <input
      disabled={!props.podeSalvar}
      value={formik.values.RazaoSocial ?? ''}
      onChange={formik.handleChange("RazaoSocial")}
      className={clsx(estilosInput.inputPadrao, estilosDadosBasicos.inputTam5)}
    />
  </div>

  const email = <div className="_mb-[4px]">
    <label className={clsx(`_py-1 _pr-3 ${estilosInput.labelObrigatorio}`)} >
      E-mail NF-e
    </label>
    <input
      disabled={!props.podeSalvar}
      value={formik.values.Email ?? ''}
      onChange={formik.handleChange("Email")}
      placeholder="Informe emails separados por ponto e vírgula"
      title="Informe emails separados por ponto e vírgula"
      maxLength={254}
      className={clsx(estilosInput.inputPadrao, estilosDadosBasicos.inputTam4, props.formularioValidado && formik.errors.Email != undefined && estilosDadosBasicos.validador)}
    />
  </div>

  const dataNascimento = <div className="_mb-[4px]">
    <label className="_py-1 _pr-3">Data Nascimento</label>
    <InputData
      id="TelaDadosBasicos_DataNascimento"
      disabled={!props.podeSalvar}
      data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataNascimento)}
      onChange={(e) => formik.setFieldValue("DataNascimento", e)}
      selecionaValorOnFocus
    />
  </div>

  const telefone = <div className="_mb-[4px]">
    <label className={clsx(`_py-1 _pr-3 ${estilosInput.labelObrigatorio}`)} >
      Telefone
    </label>
    <div><InputMascaraDinamica
      disabled={!props.podeSalvar}
      className={clsx(estilosDadosBasicos.inputTam3, formik.errors.Telefone != undefined && props.formularioValidado && estilosDadosBasicos.validador)}
      valor={formik.values.Telefone}
      onValorModificado={(value) => { value != null ? formik.setFieldValue("Telefone", value) : formik.setFieldValue("Telefone", "") }}
      mascaras={formik.values.Telefone?.startsWith("0") ?  ["(999) 9999-9999", "(999) 99999-9999"] : ["(99) 9999-9999","(99) 99999-9999",]}
    /></div>
  </div>

  const celular = <div className="_mb-[4px]">
    <label className="_py-1 _pr-3">
      Celular
    </label>
    <div><InputMascaraDinamica
      disabled={!props.podeSalvar}
      className={clsx(estilosDadosBasicos.inputTam3)}
      valor={formik.values.Celular}
      onValorModificado={(value) => { value != null ? formik.setFieldValue("Celular", value) : formik.setFieldValue("Celular", "") }}
      mascaras={formik.values.Celular?.startsWith("0") ?  ["(999) 9999-9999", "(999) 99999-9999"] : ["(99) 9999-9999","(99) 99999-9999",]}
    /></div>
  </div>

  const classificacao = <div className="_mb-[4px]">
    <label className={clsx(`_py-1 _pr-3 ${estilosInput.labelObrigatorio}`)}>
      Classificação
    </label>
    <div>
      <select
        onChange={(e) =>
          formik.setFieldValue("CodigoClassificacao", Number(e.target.value))
        }
        value={formik.values.CodigoClassificacao ?? -1}
        disabled={!props.podeSalvar}
        className={clsx(estilosInput.inputPadrao, estilosDadosBasicos.inputTam4, formik.errors.CodigoClassificacao != undefined && props.formularioValidado && estilosDadosBasicos.validador)}
      >

        <option value={-1}>Selecione</option>
        {(props.classificacoes || []).map((item, index) => (
          <option
            key={index}
            value={item.Codigo}
          >
            {item.Nome}
          </option>
        ))}

      </select>
    </div>
  </div>

  const profissao = <div className="_mb-[4px]">
    <label className="_py-1 _pr-3">Profissão</label>
    <div>
      <select
        className={clsx(estilosInput.inputPadrao, estilosDadosBasicos.inputTam4)}
        value={formik.values.NomeProfissao ?? ''}
        name="NomeProfissao"
        disabled={!props.podeSalvar}
        onChange={formik.handleChange}
      >
        <option value={undefined}>Selecione</option>
        {(props.profissoes || []).map((item, index) => (
          <option key={index} value={item.Nome}>
            {item.Nome}
          </option>
        ))}
      </select>
    </div>
  </div>

  const registroProfissional = <div className="_mb-[4px]">
    <label className="_py-1 _pr-3">Tipo / Nº Registro Profissional</label>
    <div><InputNumerico
      onValorModificado={(valor) => {
        formik.setFieldValue("TipoNumeroRegistroProfissional", valor);
      }}
      disabled={!props.podeSalvar}
      classesInput={[estilosDadosBasicos.inputTam3, estilosInput.inputPadrao]}
      valor={Number(formik.values.TipoNumeroRegistroProfissional)}
      numeroCasasDecimais={0}
      naoExibirValorZero={true}
      alinharADireita={false}
    />    </div>
  </div>

  const numeroPIS = <div className="_mb-[4px]">
    <label className="_py-1 _pr-3">Número NIT / PIS / PASEP</label>
    <div className={clsx(estilosDadosBasicos.InputMascara, estilosDadosBasicos.inputTam3)}>
      <InputMascara
        disabled={!props.podeSalvar}
        // React 19 removeu o namespace global JSX, onde o @emotion/react registrava a prop `css`
        // para qualquer componente — por isso ela só agora passou a ser rejeitada. Ela nunca teve
        // efeito: `InputMascaraProps` não declara `css`, o componente não espalha `...rest` e o
        // projeto não usa o pragma JSX do emotion. Removida sem mudança visual. Se a largura de
        // 200px for desejada, é ajuste de layout à parte.
        valor={formik.values.NumeroNitPisPasep}
        onValorModificado={(value) => { value != null ? formik.setFieldValue("NumeroNitPisPasep", value) : formik.setFieldValue("NumeroNitPisPasep", "") }}
        mascara="9.999.999.999.9"
      />
    </div>
  </div>

  const vendedorRelacionado = <div className="_mb-[4px]">
    <label className="_py-1 _pr-3"
    title="Veja parâmetros:&#013;-Visualiza vendedor relacionado na consulta do cliente?&#013;-Permite alterar o vendedor relacionado, na consulta de clientes?"
    >
      Vendedor Relacionado
    </label>

    <SelecaoComFiltro
      disabled={!props.podeSalvar}
      classNameInput="_w-[200px]"
      itens={carregandoVendedor ? [{ chave: "", valor: "Buscando..." }] : (props.vendedores ?? []).map(vendedor => ({
        chave: vendedor.Codigo.toString(),
        valor: vendedor.NomePessoa
      }))}
      onValorModificado={(vendedor) => (setCarregadoVendedor(true), props.onVendedorModificado(vendedor))}
      onItemSelecionado={item => {
        formik.setFieldValue("VendedorRelacionado", (props?.vendedores ?? []).find(b => b.Codigo.toString() == item.chave)?.NomePessoa)
      }}
      itemSelecionado={{
        chave: formik.values.CodigoVendedorRelacionado?.toString(),
        valor: formik.values.VendedorRelacionado
      }}
      filtroManual={true}
      placeholder="Digite 1 ou mais caracteres"
    />
  </div>

  return (
    <>
      {props.classificacoes && props.dadosIndicador && props.profissoes && (
        <>

          <div className={estilosDadosBasicos.form}
            id="TelaDadosBasicos_Form"
          >
            <div className={estilosDadosBasicos.linhaComUmInput}
              id="TelaDadosBasicos_LinhaCpfCnpjNome"
            >

              {cpfCnpj}

              {nome}

              {formik.values.TipoPessoa == "J" && razaoSocial}

              {email}

              {dataNascimento}

            </div>

            <div className={estilosDadosBasicos.linhaComVariosInputs}>

              {telefone}

              {celular}

            </div>

            <div className={estilosDadosBasicos.linhaComUmInput}>

              {classificacao}

              {profissao}

            </div>

            <div className={estilosDadosBasicos.linhaComVariosInputs}>

              {registroProfissional}

              {numeroPIS}

              {vendedorRelacionado}
            </div>

          </div>
        </>
      )}
    </>
  );
};
